import { render, staticRenderFns } from "./ProfileSignup.vue?vue&type=template&id=48681ead&scoped=true&"
import script from "./ProfileSignup.vue?vue&type=script&lang=js&"
export * from "./ProfileSignup.vue?vue&type=script&lang=js&"
import style0 from "./ProfileSignup.vue?vue&type=style&index=0&id=48681ead&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48681ead",
  null
  
)

export default component.exports